<div class="report-model">
    <div class="report-model-header">
        <div class="info">
            <h3>{{"reports.governmentalProperties" | translate}}</h3>
        </div>
    </div>
    <app-housevilla-inventory-properties [showLoader]="!loading" [tableColumns]="governmentalVillasColumns"
        [dataLength]="governmentalVillasCount" [tableData]="governmentalVillasdata" (pageEvent)="onPageEvent($event)"
        (sort)="sortData($event)" [allowExcelDownload]="true" (excelDownload)="downloadExcel($event, 'govt', 'b')"
        [downloadLoading]="downloadLoading['b']" [showEstaterText]="true" [type]="'govt'">
    </app-housevilla-inventory-properties>
</div>